// Variable targets are annual amounts, so monthly salaries are annualised before comparing or adding.
export function annualSalary(comp, period) {
  const base = Number(comp[`${period}Base`]) || 0;
  return String(comp.payType ?? '').trim().toLowerCase() === 'monthly' ? base * 12 : base;
}

/** Annual salary plus the target when it is an amount; percent targets can't be added. */
export function computedTotalCash(comp, period) {
  const target = comp.variableDisplayType === 'percent' ? 0 : Number(comp[`${period}VariableTarget`]) || 0;
  return annualSalary(comp, period) + target;
}

/** The target as a whole-number % of annual salary, or null where that isn't meaningful. */
export function targetPctOfSalary(comp, period) {
  const target = Number(comp[`${period}VariableTarget`]) || 0;
  const salary = annualSalary(comp, period);
  const hourly = String(comp.payType ?? '').trim().toLowerCase() === 'hourly';
  if (hourly || comp.variableDisplayType === 'percent' || !(target > 0) || !(salary > 0)) return null;
  return Math.round((target / salary) * 100);
}
